import React from 'react';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import s from './SaleBanner.scss';
import SaleIcon from '../../../assets/icons/SaleIcon.svg?url';

interface SaleBannerProps {}

const SaleBanner: React.FunctionComponent<SaleBannerProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s.strip} data-hook="saleBanner-strip">
      <div className={s.root} data-hook="saleBanner">
        <img className={s.icon} src={SaleIcon} alt="Sale Icon" />
        <div className={s.title} data-hook="saleBanner-title">
          <Trans components={{ bold: <span className={s.bold} /> }}>
            {t('sale.banner.title')}
          </Trans>
        </div>
      </div>
    </div>
  );
};

export default SaleBanner;
